var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-switch-container"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.isDisabled},domProps:{"checked":_vm.value},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }